
import { Component, Vue } from 'vue-property-decorator'
import AppBox from '@/components/AppBox.vue'
import AppButtonOutline from '@/components/AppButtonOutline.vue'
import AppInput from '@/components/AppInput.vue'
import { DebouncedFunc, debounce } from 'lodash'
import { ChildComponentMixin } from '@/mixins'

@Component({
    components: {
        AppBox,
        AppButtonOutline,
        AppInput,
    },
})
export default class HomeSearch extends ChildComponentMixin {
    public brandName: string = ''
    public brandId: string = ''
    private debounced: DebouncedFunc<(() => {})> | null = null

    /**
     * As mounted is called before this.$store.state.home.filters has all the info setted up,
     * we need to get brandName and brandId from query params.
     */
    public async mounted() {
        const brandId = this.$route.query.brand_id
        const brandName = this.$route.query.brand_name

        if (brandName !== null && typeof brandName === 'string') {
            this.brandName = brandName
        }

        if (brandId !== null && typeof brandId === 'string') {
            this.brandId = brandId
        }
    }

    public search() {
        const { status, platform, tab } = this.$store.state.home.filters
        this.$store.dispatch('home/filterApps', {
            brandName: this.brandName,
            brandId: this.brandId,
            platform,
            status,
            tab,
        })
    }

    private onTypeSearch() {
        if (this.debounced != null) {
            this.debounced.cancel()
        }
        this.debounced = debounce(async () => {
            this.search()
        }, 1000)
        this.debounced()
    }
}
